import React from "react";
import "./Playlist.css";
import { useNavigate } from "react-router-dom";


const Toegangskaarten = () => {
  const navigate = useNavigate();
  return (
    <div className="tickets-container">
      <div className="Text">

      <h1>Bestelwijze kaarten pianoconcert:</h1>
      <p>Kaarten bestellen door de volgende 2 stappen te doorlopen:</p>
      <p>1. U kunt toegangskaart(en) bestellen door het bedrag van €10,-- p.p. over te maken op de rekening van A.D. Hottinga
      NL 30 SNSB 0787 8989 96.
      Wilt u bij de omschrijving het volgende invullen: orgelconcert Petrus Kerk Botter Lelystad, uw naam, adres en woonplaats.
      </p>
      <p>2. Een e-mail te sturen aan hbghuis@gmail.com met uw naam, adres en woonplaats, zodat wij u een digitaal toegangskaart(en) kunnen toesturen.</p>
      <hr></hr>
      <p>Het is belangrijk dat u beide stappen doet, anders kunnen wij niet verifiëren of de betaling past bij het mailadres waar wij de digitale toegangskaart(en) naar toe kunnen sturen.</p>
      <hr></hr>
     
      <p>Lukt het niet om op bovenstaande wijze een kaart te bestellen, dan kunt u ook kaarten contant of per pin kopen voorafgaand aan het concert vanaf 15.00 uur en u kunt een kopje thee of koffie krijgen.</p>
      </div>
    </div>
  );
};

export default Toegangskaarten;
